"use strict";
/**
 * Created on 10 15 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ExportedPriceHistory_1 = require("../model/ExportedPriceHistory");

var ExportedPriceHistoryConverter_1 = require("./ExportedPriceHistoryConverter");

var ExportedPriceWithValidityConverter_1 = require("./ExportedPriceWithValidityConverter");
/**
 * <p>Implementation of {@link ExportedPriceWithValidityConverter}.</p>
 *
 * @author JMe
 */


var ExportedPriceHistoryConverterImpl =
/*#__PURE__*/
function (_ExportedPriceHistory) {
  _inherits(ExportedPriceHistoryConverterImpl, _ExportedPriceHistory);

  function ExportedPriceHistoryConverterImpl(priceWithValidityConverter) {
    var _this;

    _classCallCheck(this, ExportedPriceHistoryConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceHistoryConverterImpl).call(this));
    _this.priceWithValidityConverter = priceWithValidityConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ExportedPriceHistoryConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        prices: conversions.asObjectArray(source, 'prices', function (price) {
          return _this2.priceWithValidityConverter.toDocument(price, conversions);
        })
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      return new ExportedPriceHistory_1.ExportedPriceHistory(conversions.asObjectList(source, 'prices', function (doc) {
        return _this3.priceWithValidityConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return ExportedPriceHistoryConverterImpl;
}(ExportedPriceHistoryConverter_1.ExportedPriceHistoryConverter);

ExportedPriceHistoryConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ExportedPriceWithValidityConverter_1.ExportedPriceWithValidityConverter])], ExportedPriceHistoryConverterImpl);
exports.ExportedPriceHistoryConverterImpl = ExportedPriceHistoryConverterImpl;